import { render } from "./OpenPurchaseOrdersTable.vue?vue&type=template&id=2d9721ac&scoped=true"
import script from "./OpenPurchaseOrdersTable.vue?vue&type=script&lang=js"
export * from "./OpenPurchaseOrdersTable.vue?vue&type=script&lang=js"

import "./OpenPurchaseOrdersTable.vue?vue&type=style&index=0&id=2d9721ac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d9721ac"]])

export default __exports__